"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Appointment() {
  return <section data-section-id="1366" id="finalcalltoaction" className="bg-background text-foreground relative overflow-hidden py-44 md:py-56">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden md:flex items-center justify-center select-none">
        <span className="font-default font-normal leading-none" style={{
        fontSize: "28rem",
        color: "var(--primary)",
        opacity: 0.04
      }}>
          AC
        </span>
      </div>

      <div className="relative mx-auto max-w-[920px] px-6 md:px-10 text-center">
        {}
        <div className="flex items-center justify-center gap-4">
          <span className="flex items-center gap-2">
            <span className="inline-block h-px w-10" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="inline-block h-1 w-1 rounded-lg" style={{
            backgroundColor: "var(--primary)"
          }} />
          </span>
          <span className="font-default uppercase" style={{
          color: "var(--primary)",
          letterSpacing: "0.22em",
          fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)"
        }}>CLIMATE CONTROL</span>
          <span className="flex items-center gap-2">
            <span className="inline-block h-1 w-1 rounded-lg" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="inline-block h-px w-10" style={{
            backgroundColor: "var(--primary)"
          }} />
          </span>
        </div>

        {}
        <h2 className="font-default font-normal mt-12 text-foreground" style={{
        fontSize: "clamp(2.75rem, 6.5vw, 6rem)",
        lineHeight: 0.98,
        letterSpacing: "-0.025em",
        fontWeight: 600
      }}>
          Your comfort is our{" "}
          <em className="italic" style={{
          fontStyle: "italic",
          color: "var(--primary)"
        }}>
            priority
          </em>{" "}
          all year.
        </h2>

        {}
        <p className="font-default mt-12 text-muted-foreground mx-auto max-w-2xl" style={{
        fontSize: "clamp(0.9375rem, 1.05vw, 1.0625rem)",
        lineHeight: 1.65,
        letterSpacing: "0.005em"
      }}>Coastline Air Conditioning Services provides expert air conditioning installation and maintenance services across Sussex. Book your consultation today.</p>

        {}
        <div className="mt-16 flex justify-center">
          <Button asChild className="group bg-primary text-primary-foreground hover:bg-background hover:text-primary border border-transparent hover:border-primary uppercase font-default transition-all duration-300 rounded-lg w-full sm:w-auto px-6 sm:px-9 py-6 h-auto shadow-md" style={{
          fontSize: "0.875rem",
          letterSpacing: "0.18em",
          fontWeight: 600
        }}>
            <Link to="#contact-form">
              <span>Book Service</span>
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-24 font-default uppercase" style={{
        color: "var(--muted-foreground)",
        fontSize: "0.6875rem",
        letterSpacing: "0.18em"
      }}>
          Serving Sussex & Surrey — Professional Climate Solutions
        </div>
      </div>
    </section>;
}